import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { BankService } from '../../../core/services/bank/bank/bank.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'bank-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatSlideToggle,
  ],
  templateUrl: './bank-edit.component.html',
  styleUrl: './bank-edit.component.scss',
  providers: [BankService],
  standalone: true,
})
export class BankEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private bankService: BankService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<BankEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.bankService.editBank(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      codigoBanco: this.form.controls['code_bank'].value,
      nome: this.form.controls['name'].value,
      statusBanco: this.form.get('active')?.value == true ? 'S' : 'N',
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      code_bank: [this.itemEdit.codigoBanco, [Validators.required]],
      name: [this.itemEdit.nome, [Validators.required]],
      active: [this.itemEdit.ativo == 'Ativo' ? true : false],
    })
    this.form.get('code')?.disable()
  }
}
